const data = [
  {
    name: "Background",
    content: [
      {
        type: "text",
        name: "Bio",
        value:
          "As an innovative and performance-driven software developer, I have spent over five years honing my craft in web development and software engineering. My journey began with a passion for solving technical challenges, which has evolved into a career focused on building user-friendly, cost-saving solutions. Throughout my career, I have developed a diverse skill set, ranging from mentoring teams of developers to leading full-scale projects from concept to delivery. I thrive in environments that push boundaries and demand creative problem-solving, always aiming to deliver solutions that not only meet but exceed expectations.",
      },
      {
        type: "text",
        name: "Training",
        value:
          "My educational journey laid a solid foundation for my career in technology. I completed my studies at ISTA in Marrakesh, earning a degree as a Specialized Technician in Computer Science. These formative years were vital in building my technical knowledge and understanding the broader context of software development.\n\nAfterwards I joined 1337, for the Architect in Digital Technologies program. I was instrumental in shaping my skills in software engineering, allowing me to gain hands-on experience with cutting-edge technologies.",
      },
      {
        type: "text",
        name: "Career",
        value:
          "My professional journey began as a Freelance Web Developer where I built a portfolio of responsive websites and applications for a diverse clientele. Each project presented its own set of challenges, from gathering requirements to developing custom solutions and managing everything from design to deployment. Working independently, I was responsible for ensuring that every project was delivered on time and within budget, which helped me develop strong project management skills.\n\nIn 2020, I co-founded IM Creation as a technical director where I took on a leadership role in driving the technology strategy to meet clients' goals. My responsibilities went beyond coding; I managed a multidisciplinary team of designers, and tech professionals, ensuring that each project was executed seamlessly from concept to completion. I also introduced quality control processes that improved the overall standard of our web projects. This position allowed me to grow both as a leader and as a technical expert, as I was responsible for overseeing all aspects of project delivery.\n\nIn September 2023, I embraced a new challenge at Ark-x Talent Factory as an Instructor and Software Developer. Here, I mentor aspiring developers, sharing my knowledge of programming and engineering to help them grow into skilled professionals. Beyond teaching, I am also responsible for creating engaging curriculum content tailored for our learning management system. My role includes designing custom software solutions to optimize the company's internal operations, ensuring that our team stays on track with project deliverables and making improvements where necessary.",
      },
    ],
  },
  {
    name: "1337",
    content: [
      {
        type: "text",
        name: "Overview",
        value:
          "In March 2019, I embarked on my journey at 1337, the Moroccan branch of the 42 Network, after successfully surviving the infamous pool month. The early days were intense, filled with countless hours in front of a screen, as I tackled the intricacies of the C language—wrestling with memory management, mastering pointers, and diving deep into advanced algorithms. After conquering several projects in this realm, I shifted gears and ventured into graphics, creating visual magic with the minilibX library. As my skills sharpened, I transitioned into the web development branch, starting with PHP before embracing the dynamic world of the JavaScript stack. It was during the first internship project, however, that I made the difficult decision to leave the program and focus on my professional career. My time at 1337 may have been cut short, but it set the foundation for everything that followed.",
      },
      {
        type: "image",
        name: "42-graph",
        value: "/data/42.png",
      },
      {
        type: "folder",
        name: "Projects",
        content: [
          {
            type: "folder",
            name: "Fillit",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A program developed in C, that uses backtracking to arrange a set of Tetriminos given in an input file, into the smallest possible square grid.",
              },
              {
                type: "image",
                name: "fillit",
                value: "/data/fillit.gif",
              },
            ],
          },
          {
            type: "folder",
            name: "Fractol",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A graphical program in C to generate and visualize fractals, including the Mandelbrot and Julia sets. The project focused on implementing complex number mathematics, real-time rendering, and infinite zoom scroll.",
              },
              {
                type: "image",
                name: "fractol",
                value: "/data/fractol.gif",
              },
            ],
          },
          {
            type: "folder",
            name: "Camagru",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "An Instagram-like application using PHP and JavaScript that allows users to capture photos with their webcam, apply filters, and share them with other users.",
              },
              {
                type: "image",
                name: "camagru",
                value: "/data/camagru.png",
              },
            ],
          },
          {
            type: "folder",
            name: "Matcha",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A dating web application using Node.js, featuring real-time messaging, user geolocation, profile recommendations, and advanced search filters. The project also included user management, and an algorithm for matching users based on interests and location.",
              },
              {
                type: "image",
                name: "matcha",
                value: "/data/matcha.png",
              },
            ],
          },
          {
            type: "folder",
            name: "Hypertube",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A video streaming platform using Node.js, allowing users to search, stream, and download torrent-based content. The project included video transcoding and real-time torrent management, with a focus on delivering a seamless streaming experience.",
              },
              {
                type: "image",
                name: "hypertube",
                value: "/data/hypertube.png",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "IM Creation",
    content: [
      {
        type: "text",
        name: "Company",
        value:
          "IM Creation, based in Marrakech, is a specialized agency focused on creating cutting-edge digital content and tailored solutions for businesses. With a strong foundation in web development and digital marketing, the agency leverages its technical expertise to deliver high-quality websites, applications, and content strategies that drive engagement.",
      },
      {
        type: "text",
        name: "Role",
        value:
          "As the co-founder and technical director of IM-Creation, I played a pivotal role in shaping the agency's technology strategy to meet the diverse needs of our clients. My responsibilities extended far beyond coding; I led a multidisciplinary team of designers and technical professionals, ensuring each project was delivered efficiently and met the highest standards. By introducing robust quality control processes, I enhanced the consistency and performance of our web projects. This leadership role allowed me to grow both as a strategic thinker and a technical expert, overseeing the entire project lifecycle from concept to completion.",
      },
      {
        type: "folder",
        name: "Projects",
        content: [
          {
            type: "folder",
            name: "IM Creation",
            content: [
              {
                type: "text",
                name: "about",
                value: "The Official website of the agency.",
              },
              {
                type: "image",
                name: "imcreation",
                value: "/data/imcreation.gif",
              },
            ],
          },
          {
            type: "folder",
            name: "IM Reporting",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A web application used to share reporting from press and social media listening with active clients. [Blurred Data]",
              },
              {
                type: "image",
                name: "imreporting",
                value: "/data/imreporting.png",
              },
            ],
          },
          {
            type: "folder",
            name: "IM Solution",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A web application for social listening with an advanced UX and features including AI data processing. [Blurred Data]",
              },
              {
                type: "image",
                name: "imsolution",
                value: "/data/imsolution.png",
              },
            ],
          },
          {
            type: "folder",
            name: "BrandBeat",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "The backoffice of a web application for social media monitoring using Minimal template. [Blurred Data]",
              },
              {
                type: "image",
                name: "brandbeat",
                value: "/data/brandbeat.png",
              },
            ],
          },
          {
            type: "folder",
            name: "CPGE Ibn Ghazi",
            content: [
              {
                type: "text",
                name: "about",
                value: "Ibn Ghazi's Landing Page built with WordPress.",
              },
              {
                type: "image",
                name: "ibnghazi",
                value: "/data/ibnghazi.png",
              },
            ],
          },
          {
            type: "folder",
            name: "El Fanous Prod",
            content: [
              {
                type: "text",
                name: "about",
                value: "El Fanous's Landing Page built with WordPress.",
              },
              {
                type: "image",
                name: "elfanousprod",
                value: "/data/elfanousprod.png",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Ark-x",
    content: [
      {
        type: "text",
        name: "Company",
        value:
          "Ark-x is a tech-focused organization in Morocco, established in 2019 to address skill gaps in the local and regional tech sectors. With a strong focus on upskilling and reskilling initiatives designed to help close the talent gap and support Morocco's tech ecosystem.",
      },
      {
        type: "text",
        name: "Role",
        value:
          "As an instructor and software developer at Ark-x, I mentor aspiring tech professionals in Morocco, equipping them with essential software development skills through hands-on training. In addition to teaching, I contribute to project development of tools and platforms that support our mission of advancing the local tech ecosystem. This role allows me to shape the next generation of developers while actively contributing to impactful tech solutions that drive growth and innovation.",
      },
      {
        type: "folder",
        name: "Projects",
        content: [
          {
            type: "folder",
            name: "Confidential",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A web application that uses data scraping from the web, stores the result into the database and uses AI-powered processing to extract and update data fields to generate advanced insights and statistics. [Blurred Data]",
              },
              {
                type: "image",
                name: "arkx-1",
                value: "/data/arkx-1.png",
              },
            ],
          },
          {
            type: "folder",
            name: "Assessment App",
            content: [
              {
                type: "text",
                name: "about",
                value:
                  "A web application used to manage assessments and other candidate-related data during their journey. [Blurred Data]",
              },
              {
                type: "image",
                name: "arkx-2",
                value: "/data/arkx-2.png",
              },
            ],
          },
        ],
      },
    ],
  },
];

export default data;
